import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {BettingCenter} from '../betting-center.js';

import {overaskFactory} from './overask.factory';

import PALETTE_SCHEMA from './overask.palette-schema.yaml';

class OveraskFeature extends AbstractVisualFeature {
    get name() {
        return 'Overask';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return overaskFactory(PALETTE);
    }
}

new OveraskFeature(BettingCenter);
